<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-b">Contents</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc-bot"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc-bot"><a href="#/xhtml/part1#pt1"><span class="epub-b">Over mountains to inns</span><br/>Traveling in the Europe of five hundred years ago</a></p>
<p class="toc-bot"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample">The banker’s road<br/><span class="epub-b">From Florence to Bruges</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample">Furs<br/><span class="epub-b">From Lübeck to Novgorod</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part4#pt4" title="Link target outside of Sample">The pilgrim’s shell<br/><span class="epub-b">From Vézelay to Santiago de Compostela</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part5#pt5" title="Link target outside of Sample">The armor merchant<br/><span class="epub-b">From Milan to Mont-Saint-Michel</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part6#pt6" title="Link target outside of Sample">The painter<br/><span class="epub-b">From Nuremberg to Venice</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part7#pt7" title="Link target outside of Sample">Jubilee<br/><span class="epub-b">From Trondheim to Rome</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part8#pt8" title="Link target outside of Sample">The archer of the king of France<br/><span class="epub-b">From Edinburgh to Paris</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part9#pt9" title="Link target outside of Sample">The door to Asia<br/><span class="epub-b">From Genoa to Istanbul</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part10#pt10" title="Link target outside of Sample">The shipbuilder<br/><span class="epub-b">From Seville to Antwerp</span></span></p>
<p class="toc-bot"><span href="#/xhtml/part11#pt11" title="Link target outside of Sample">The ambassador<br/><span class="epub-b">From Vienna to Moscow</span></span></p>
<p class="toc"><span href="#/xhtml/chr#chr" title="Link target outside of Sample">Chronology</span></p>
<p class="toc"><span href="#/xhtml/bib#bib" title="Link target outside of Sample">Bibliographical notes</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/photo#photo" title="Link target outside of Sample">Photographic Credits</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?73656fae